module.exports = __webpack_public_path__ + "static/media/rising-up-bg.90673ef1.svg";